import { useState } from 'react';
import { PenLine } from 'lucide-react';
import { cn } from '@eombor/ui';
import { t } from '../../../shared/i18n/index.js';
import { SignaturePad } from './SignaturePad.js';
import { useMySignature, useSaveSignature } from '../model/signature.queries.js';

/**
 * «IMZONGIZ HALI YO'Q» — tasdiqlash oynasidagi bir martalik bo'lim.
 *
 * Imzo BOR bo'lsa hech narsa chizilmaydi: xodim uni bir marta chizadi va
 * keyingi safar bu bo'lim ko'rinmaydi. Shuning uchun uni profilga qo'yish
 * o'rniga aynan shu yerga qo'yish tanlandi — odam profilga tasodifan kirmaydi
 * va imzosi umrbod bo'sh qolib ketardi.
 *
 * Ish TO'XTAMAYDI: «Keyinroq» bosilsa bo'lim yopiladi va tasdiqlash odatdagidek
 * davom etadi, hujjatdagi katak esa bo'sh chiqib, qog'ozda qo'lda imzolanadi.
 *
 * So'rov yiqilsa ham hech narsa chizilmaydi: imzo qo'shimcha qulaylik va
 * uning yo'qligi qabul qilishni to'xtatmasligi kerak.
 */
export const SignatureSetup = () => {
  const signature = useMySignature();
  const save = useSaveSignature();
  const [skipped, setSkipped] = useState(false);

  if (signature.isPending || signature.isError) return null;
  if (signature.data.fileId !== null || skipped) return null;

  return (
    <section
      aria-label={t('signature.section')}
      className={cn(
        'flex flex-col gap-2 rounded-[var(--radius-md)] border border-dashed border-border-strong',
        'bg-surface-2 p-3',
      )}
    >
      <p className="flex items-center gap-2 text-sm font-medium text-text">
        <PenLine size={14} aria-hidden />
        {t('signature.setupTitle')}
      </p>
      <p className="text-xs text-text-muted">{t('signature.setupHint')}</p>

      <SignaturePad
        busy={save.isPending}
        onSkip={() => setSkipped(true)}
        onDone={(file) => save.mutate(file)}
      />

      {save.isError ? (
        <p className="text-xs text-danger">{t('signature.setupError')}</p>
      ) : null}
    </section>
  );
};
